


















import { KpiEnum } from '../../enums';

export default {
  name: 'kpi-not-available',
  props: {
    kpi: {
      type: String,
      required: true
    },
    vertical: {
      type: Boolean
    }
  },
  data: function () {
    return {
      messages: this.$epb.messages.analytics
    };
  },
  computed: {
    kpiIcon: function (): string {
      return {
        [KpiEnum.ADD2CART]: () => 'add2cart',
        [KpiEnum.CHECKOUT]: () => 'checkout'
      }[this.kpi]();
    },
    kpiTitleText: function (): string {
      return {
        [KpiEnum.ADD2CART]: () => `${ this.messages.kpis[KpiEnum.ADD2CART].percentageLabel }?`,
        [KpiEnum.CHECKOUT]: () => `${ this.messages.kpis[KpiEnum.CHECKOUT].percentageLabel }?`
      }[this.kpi]();
    }
  }
};
